import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/views/Login'
import AddressBook from '@/components/views/AddressBook'
import AddressBookList from '@/components/views/AddressBookList'
import ContactDetailView from '@/components/views/ContactDetailView'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    component: AddressBook,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Home',
        redirect: '/contacts',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'contacts',
        name: 'Contacts',
        component: AddressBookList,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':id',
            name: 'ContactDetail',
            component: ContactDetailView,
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ]
  }
]

export function createRouter (config) {
  const STORAGE_TOKEN_ID = config.STORAGE_TOKEN_ID

  const isUserAuthenticated = () => {
    return !!localStorage.getItem(STORAGE_TOKEN_ID)
  }

  const authGuard = (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!isUserAuthenticated()) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else {
      next() // make sure to always call next()!
    }
  }

  const router = new Router({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      if (to.hash) {
        return { selector: to.hash }
      }
      return { x: 0, y: 0 }
    }
  })

  router.beforeEach(authGuard)

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js